import { NavLink, Outlet } from "react-router-dom";
import SlideModal from "../components/SlideModal";
import '../styles/pages/page.scss'
import '../styles/pages/system.scss'

const System = () => (
    <div className="page-container">
        <div className="main-container">
            <h1 className="main-title">
                System
            </h1>
            <div className="system-nav">
                <NavLink to='/system/1' className={({isActive})=>isActive ? 'active-link' : 'inactive' }>
                    <button className="system-nav-yellow"></button>
                </NavLink>
                <NavLink to='/system/2' className={({isActive})=>isActive ? 'active-link' : 'inactive' }>
                    <button className="system-nav-orange"></button>
                </NavLink>
                <NavLink to='/system/3' className={({isActive})=>isActive ? 'active-link' : 'inactive' }>
                    <button className="system-nav-blue"></button>
                </NavLink>
                <NavLink to='/system/4' className={({isActive})=>isActive ? 'active-link' : 'inactive' }>
                    <button className="system-nav-pink"></button>
                </NavLink>
                <NavLink to='/system/5' className={({isActive})=>isActive ? 'active-link' : 'inactive' }>
                    <button className="system-nav-green"></button>
                </NavLink>
                <NavLink to='/system/6' className={({isActive})=>isActive ? 'active-link' : 'inactive' }>
                    <button className="system-nav-red"></button>
                </NavLink>
            </div>
            <Outlet/>
        </div>
    </div>
)
export default System;

const Overview = () => {

    const images = ["/img/system/overview/ss0.jpg", "/img/system/overview/ss1.png", "/img/system/overview/ss2.jpg", "/img/system/overview/ss3.jpg"]

    return (
        <>
            <h1 className="main-header">
                Search for Lost Memories
            </h1>
            <p className="system-text">
                The young protagonist wanders the streets of her town at night in search of mementos that will help her remember how to break the curse that's been placed on her.<br/>
                However, terrifying spirits lurk in the shadows. The girl will need to use the light of her flashlight and listen for her heartbeat in order to escape from these spirits and recover her <span className="blue">lost memories</span>.
            </p>
            <div className="ss-container">
                <SlideModal images={images} changeTo={0}>
                    <img src={`${process.env.PUBLIC_URL}/img/system/overview/ss0.jpg`} alt="screenshot" />
                </SlideModal>
                <SlideModal images={images} changeTo={1}>
                    <img src={`${process.env.PUBLIC_URL}/img/system/overview/ss1.png`} alt="screenshot" />
                </SlideModal>
        </div>
            <h1 className="main-header">
                Guided by a Faint Light
            </h1>
            <p className="system-text">
                The only source of <span className="blue">light</span> the girl can rely on is the <span className="blue">flashlight</span> she holds. By <span className="blue">shining it into the darkness</span>, she can see both <span className="blue">helpful items</span> on the ground and malicious <span className="blue">spirits</span>.
            </p>
            <div className="ss-container">
                <div className="screenshot-pair">
                    <SlideModal images={images} changeTo={2}>
                        <img src={`${process.env.PUBLIC_URL}/img/system/overview/ss2.jpg`} alt="screenshot" />
                    </SlideModal>
                    <h2 className="image-caption">
                        Helpful items will sparkle when the flashlight is shone over them.
                    </h2>
                </div>
                <div className="screenshot-pair">
                    <SlideModal images={images} changeTo={3}>
                        <img src={`${process.env.PUBLIC_URL}/img/system/overview/ss3.jpg`} alt="screenshot" />
                    </SlideModal>
                    <h2 className="image-caption">
                        Approaching spirits will also be revealed by the flashlight. When your heart begins to beat faster, shine it around to see if any are nearby.
                    </h2>
                </div>
            </div>
        </>
    )
}

const SystemPage = () => {

    const images = ["/img/system/systempage/ss0.jpg", "/img/system/systempage/ss1.jpg", "/img/system/systempage/ss2.jpg", "/img/system/systempage/ss3.jpg", "/img/system/systempage/ss4.png", "/img/system/systempage/ss5.jpg", "/img/system/systempage/ss6.jpg"]

    return (
        (
            <>
                <h1 className="main-header">
                    Spirits in the Dark
                </h1>
                <div className="ss-pair">
                    <div className="text">
                        <p className="system-text">
                            After night falls, eerie and terrifying spirits walk the empty streets of the town.<br/>
                            From under flickering street lights and through pitch-black alleyways, they watch the young girl...
                        </p>
                    </div>
                    <SlideModal images={images} changeTo={0}>
                        <img src={`${process.env.PUBLIC_URL}/img/system/systempage/ss0.jpg`} alt="screenshot" />
                    </SlideModal>
                </div>
                <p className="system-text">
                    Use your <span className="blue">flashlight</span> to reveal spirits, throw <span className="blue">pebbles</span> to distract them, and do everything you can to avoid being caught.
                </p>
                <div className="ss-pair">
                    <SlideModal images={images} changeTo={1}>
                    <img src={`${process.env.PUBLIC_URL}/img/system/systempage/ss1.jpg`} alt="screenshot" />
                    </SlideModal>
                    <SlideModal images={images} changeTo={2}>
                    <img src={`${process.env.PUBLIC_URL}/img/system/systempage/ss2.jpg`} alt="screenshot" />
                    </SlideModal>
                </div>
                <h1 className="main-header">
                    Out of Sight
                </h1>
                <p className="system-text">
                    By closing your eyes, you can avoid the gaze of the evil spirits, causing them to lose sight of you.<br/>
                    Sometimes, stopping to close your eyes and hiding may be a good opportunity to escape your fears.
                </p>
                <p className="system-text">
                    However, don't forget that the spirits are still there, even when your eyes are closed. <br/>
                    If you shut your eyes, be sure to avoid running into a spirit as you flee to somewhere safer.
                </p>
                <div className="ss-pair">    
                    <SlideModal images={images} changeTo={3}>
                        <img src={`${process.env.PUBLIC_URL}/img/system/systempage/ss3.jpg`} alt="screenshot" />
                    </SlideModal>
                </div>
                <h1 className="main-header">
                    One Man's Trash
                </h1>
                <p className="system-text">
                    Strewn about the town's streets are various items that can help the girl in her search.
                </p>
                <div className="ss-pair">
                    <div className="text">
                        <p className="system-text">
                            Pebbles lying on the roadside, notes written by mysterious individuals...<br/>
                            These things and more may prove to be useful. Some items provide information and others can be used directly to help your exploration.
                        </p>
                        <p className="system-text">
                            Make good use of everything you find as you search the shadows of your hometown.
                        </p>
                    </div>
                    <SlideModal images={images} changeTo={4}>
                     <img src={`${process.env.PUBLIC_URL}/img/system/systempage/ss4.png`} alt="screenshot" />
                    </SlideModal>
                </div>
                <div className="ss-pair">    
                    <SlideModal images={images} changeTo={5}>
                        <img src={`${process.env.PUBLIC_URL}/img/system/systempage/ss5.jpg`} alt="screenshot" />
                    </SlideModal>
                    <SlideModal images={images} changeTo={6}>
                        <img src={`${process.env.PUBLIC_URL}/img/system/systempage/ss6.jpg`} alt="screenshot" />
                    </SlideModal>
                </div>
            </>
        )
    )
}

const Memories = () => {

    const images = ["/img/system/memories/ss0.jpg", "/img/system/memories/ss1.jpg", "/img/system/memories/ss2.jpg", "/img/system/memories/ss3.jpg", "/img/system/memories/ss4.jpg", "/img/system/memories/ss5.jpg", "/img/system/memories/ss6.jpg", "/img/system/memories/ss7.jpg"]

    return (
        (
            <>
                <h1 className="main-header">
                    Precious Memories, Forgotten
                </h1>
                <p className="system-text">
                    The girl must <span className="blue">find the memories she's lost</span> in order to remember how to <span className="blue">break the curse</span> placed on her.<br/> 
                    The <span className="blue">mementos</span> scattered across the town will each restore a memory associated with them.
                </p>
                <p className="system-text">
                    You can look back at the memories you've recovered from your notebook at home. Collect all the missing mementos and find a way to break the curse.
                </p>
                <div className="ss-pair">    
                    <SlideModal images={images} changeTo={0}>
                        <img src={`${process.env.PUBLIC_URL}/img/system/memories/ss0.jpg`} alt="screenshot" />
                    </SlideModal>
                    <SlideModal images={images} changeTo={1}>
                    <img src={`${process.env.PUBLIC_URL}/img/system/memories/ss1.jpg`} alt="screenshot" />
                    </SlideModal>
                </div>
                <h1 className="main-header">
                    Shadows of the Town
                </h1>
                <p className="system-text">
                    There are a number of places across the town that are the sites of tragic stories.
                </p>
                <div className="ss-pair">
                    <div className="text">
                        <p className="system-text">
                            You can choose to explore the different parts of the town in any order you choose. The <span className="blue">silent hallways of the school</span>, the <span className="blue">rice fields in the nearby countryside</span>, a <span className="blue">mansion filled with dolls within a bamboo forest</span>... Each location's unique history has given rise to different spirits, lurking in the darkness and guarding the lost <span className="blue">memento</span> in that area.
                        </p>
                    </div>
                    <SlideModal images={images} changeTo={2}>
                    <img src={`${process.env.PUBLIC_URL}/img/system/memories/ss2.jpg`} alt="screenshot" />
                    </SlideModal>
                </div>
                <p className="system-text">
                    Venture out into the streets of your town and find your forgotten memories before dawn breaks.
                </p>
                <div className="ss-pair">    
                    <SlideModal images={images} changeTo={3}>
                    <img src={`${process.env.PUBLIC_URL}/img/system/memories/ss3.jpg`} alt="screenshot" />
                    </SlideModal>
                    <SlideModal images={images} changeTo={4}>
                    <img src={`${process.env.PUBLIC_URL}/img/system/memories/ss4.jpg`} alt="screenshot" />
                    </SlideModal>
                </div>
                <h1 className="main-header">
                    Scattered Mementos
                </h1>
                <p className="system-text">
                    Once the girl finds one of the mementos she's lost, she can revisit the memory associated with it.
                </p>
                <p className="system-text">
                    A <span className="blue">small pencil</span> used at school, an <span className="blue">old seashell</span> she picked up on the beach...
                </p>
                <p className="system-text">
                    No matter how mundane the item is, it still has a story to tell. Each memento you find will show you a scene from the past. Return to the <span className="blue">places these memories show you</span>, and you may discover even more.
                </p>
                <div className="ss-container">
                    <SlideModal images={images} changeTo={5}>
                    <img src={`${process.env.PUBLIC_URL}/img/system/memories/ss5.jpg`} alt="screenshot" />
                    </SlideModal>
                    <SlideModal images={images} changeTo={6}>
                    <img src={`${process.env.PUBLIC_URL}/img/system/memories/ss6.jpg`} alt="screenshot" />
                    </SlideModal>
                    <div className="screenshot-pair">
                        <SlideModal images={images} changeTo={7}>
                        <img src={`${process.env.PUBLIC_URL}/img/system/memories/ss7.jpg`} alt="screenshot" />
                        </SlideModal>
                        <h2 className="image-caption">
                        If you try to go to a place you don't yet remember, the <span className="blue">bird spirit</span> will appear and chase you away. Find a memento that reminds you of the area, and the path will be clear.
                        </h2>
                    </div>
                </div>
            </>
        )
    )
}

const Areas = () => {

    const images = ["/img/system/areas/ss0.jpg", "/img/system/areas/ss1.png", "/img/system/areas/ss2.png", "/img/system/areas/ss3.jpg", "/img/system/areas/ss4.jpg", "/img/system/areas/ss5.jpg", "/img/system/areas/ss6.jpg", "/img/system/areas/ss7.png", "/img/system/areas/ss8.jpg", "/img/system/areas/ss9.jpg", "/img/system/areas/ss10.jpg", "/img/system/areas/ss11.jpg"]

    return (
        (
            <>
                <h1 className="main-header">
                    The School at Night
                </h1>
                <div className="ss-container">
                    <div className="screenshot-pair">
                        <SlideModal images={images} changeTo={0}>
                            <img src={`${process.env.PUBLIC_URL}/img/system/areas/ss0.jpg`} alt="screenshot" />
                        </SlideModal>
                        <h2 className="image-caption">
                        Silent, empty classrooms. Hallways dimly lit by the red lights from the fire alarms. The well-used pages of an <span className="blue">exchange diary</span> give clues on how to move forward.
                        </h2>
                    </div>
                    <div className="screenshot-pair">
                        <SlideModal images={images} changeTo={1}>
                            <img src={`${process.env.PUBLIC_URL}/img/system/areas/ss1.png`} alt="screenshot" />
                        </SlideModal>
                        <h2 className="image-caption">
                        Scribbled in the corners of a notebook are a series of notes from <span className="blue">two unknown people</span>.
                        </h2>
                    </div>
                    <div className="screenshot-pair">
                        <SlideModal images={images} changeTo={2}>
                            <img src={`${process.env.PUBLIC_URL}/img/system/areas/ss2.png`} alt="screenshot" />
                        </SlideModal>
                        <h2 className="image-caption">
                        The notes mention <span className="blue">rumors of terrifying ghosts</span> lurking in the school. Are they just urban legends, or is there truth to these rumors...?
                        </h2>
                    </div>
                </div>
                <h1 className="main-header">
                    The Howling District
                </h1>
                <div className="ss-container">
                    <div className="screenshot-pair">
                        <SlideModal images={images} changeTo={3}>
                            <img src={`${process.env.PUBLIC_URL}/img/system/areas/ss3.jpg`} alt="screenshot" />
                        </SlideModal>
                        <h2 className="image-caption">
                        A deserted shopping district with a heavy atmosphere. Stray dogs gather in random spots, barking into the <span className="blue">empty darkness</span>.
                        </h2>
                    </div>
                    <div className="screenshot-pair">
                        <SlideModal images={images} changeTo={4}>
                            <img src={`${process.env.PUBLIC_URL}/img/system/areas/ss4.jpg`} alt="screenshot" />
                        </SlideModal>
                        <h2 className="image-caption">
                        The dogs don't seem to notice the girl. They simply continue barking into the darkness.
                        </h2>
                    </div>
                    <div className="screenshot-pair">
                        <SlideModal images={images} changeTo={5}>
                            <img src={`${process.env.PUBLIC_URL}/img/system/areas/ss5.jpg`} alt="screenshot" />
                        </SlideModal>
                        <h2 className="image-caption">
                        Some paths will be blocked by the dogs. If you can get their attention with something, they might move out of the way.
                        </h2>
                    </div>
                </div>
                <h1 className="main-header">
                    The Ghost Ship
                </h1>
                <div className="ss-container">
                    <div className="screenshot-pair">
                        <SlideModal images={images} changeTo={6}>
                            <img src={`${process.env.PUBLIC_URL}/img/system/areas/ss6.jpg`} alt="screenshot" />
                        </SlideModal>
                        <h2 className="image-caption">
                        An abandoned ship left to rust in pitch darkness. For some reason, any flashlights or watches brought on board will go <span className="blue">out of control</span>.
                        </h2>
                    </div>
                    <div className="screenshot-pair">
                        <SlideModal images={images} changeTo={7}>
                            <img src={`${process.env.PUBLIC_URL}/img/system/areas/ss7.png`} alt="screenshot" />
                        </SlideModal>
                        <h2 className="image-caption">
                        An <span className="blue">old camera</span> has been left on the ship. Perhaps its flash may prove useful.
                        </h2>
                    </div>
                    <div className="screenshot-pair">
                        <SlideModal images={images} changeTo={8}>
                            <img src={`${process.env.PUBLIC_URL}/img/system/areas/ss8.jpg`} alt="screenshot" />
                        </SlideModal>
                        <h2 className="image-caption">
                        A <span className="blue">note</span> was left by the captain, claiming that there's something outside the ship...
                        </h2>
                    </div>
                </div>
                <h1 className="main-header">
                    The Forgotten Graveyard
                </h1>
                <div className="ss-container">
                    <div className="screenshot-pair">
                        <SlideModal images={images} changeTo={9}>
                            <img src={`${process.env.PUBLIC_URL}/img/system/areas/ss9.jpg`} alt="screenshot" />
                        </SlideModal>
                        <h2 className="image-caption">
                        A <span className="blue">neglected graveyard</span> whose graves have gone untended for years. Pale figures stare out at you from their desolate resting places.
                        </h2>
                    </div>
                    <div className="screenshot-pair">
                        <SlideModal images={images} changeTo={10}>
                            <img src={`${process.env.PUBLIC_URL}/img/system/areas/ss10.jpg`} alt="screenshot" />
                        </SlideModal>
                        <h2 className="image-caption">
                        A ghost that clings to its lonely grave. It <span className="blue">doesn't move</span> at all, but looks expectantly at you, as if asking for something.
                        </h2>
                    </div>
                    <div className="screenshot-pair">
                        <SlideModal images={images} changeTo={11}>
                            <img src={`${process.env.PUBLIC_URL}/img/system/areas/ss11.jpg`} alt="screenshot" />
                        </SlideModal>
                        <h2 className="image-caption">
                        The ghost of a man that silently stares at an old incinerator. Is there something <span className="blue">inside</span>...?
                        </h2>
                    </div>
                </div>
            </>
        )
    )
}

const Spirits = () => (
    <>  
        <div className="main-header">
            Those that Haunt the Midnight Streets
        </div>
        <div className="monster-container">
            <h1 className="name">
                Large Faceless Man
            </h1>
            <img src={`${process.env.PUBLIC_URL}/img/system/monsters/obake01.png`} alt="Large Faceless Man" className="monster-img" />
            <p className="monster-desc">
            His <span className="blue">long, thin arm</span> drags a <span className="blue">giant scythe</span> along the ground. He relentlessly pursues the girl until she's able to escape elsewhere.
            </p>
        </div>
        <div className="monster-wrapper">
            <div className="monster-container small">
                <h1 className="name">
                Science Lab Skeleton
                </h1>
                <img src={`${process.env.PUBLIC_URL}/img/system/monsters/obake02.png`} alt="Science Lab Skeleton" className="monster-img" />
                <p className="monster-desc">
                A seemingly ordinary skeleton display that resides in the school's science room. Rumor has it, though, that it <span className="blue">moves when you close your eyes</span>.
                </p>
            </div>
            <div className="monster-container small">
                <h1 className="name">
                Roadblocker
                </h1>
                <img src={`${process.env.PUBLIC_URL}/img/system/monsters/obake03.png`} alt="Roadblocker" className="monster-img" />
                <p className="monster-desc">
                A <span className="blue">gigantic spirit</span> that looms over the shopping district. It's so large that it blocks the entire road. Its many eyes stare menacingly at passerby, as if to stop them in their tracks.
                </p>
            </div>
            <div className="monster-container small">
                <h1 className="name">
                Water Spirit
                </h1>
                <img src={`${process.env.PUBLIC_URL}/img/system/monsters/obake04.png`} alt="Water Spirit" className="monster-img" />
                <p className="monster-desc">
                A spirit that jumps out of puddles. It <span className="blue">wobbles, gushes, and changes form</span> as it approaches its victims.
                </p>
            </div>
            <div className="monster-container small">
                <h1 className="name">
                Three Spirits
                </h1>
                <img src={`${process.env.PUBLIC_URL}/img/system/monsters/obake05.png`} alt="Three Spirits" className="monster-img" />
                <p className="monster-desc">
                These spirits sit in a forgotten corner of the graveyard, blocking the road.
                </p>
            </div>
        </div>
    </>
)

const BirdSpirit = () => (
    <>
        <h1 className="main-header">
        Whispered Rumors of a Bird Spirit
        </h1>
        <div className="bird-container">
            <img src={`${process.env.PUBLIC_URL}/img/system/monsters/bird.png`} alt="screenshot" />
            <div className="text-container">
                There is an old rumor about a bird spirit by the name of Kotori that has been passed down in the town for many generations.<br/>
                This spirit is said to observe all time at once with its unblinking eye. Some say it watches over the town, but the truth has been lost to the ages.<br/>
                It wanders the darkened streets of the town at night, seemingly looking...or perhaps waiting for someone. <br/>
                Those who venture out into the town had best take care to avoid this mysterious entity.
            </div>
        </div>
    </>
)

export {
    System,
    Overview,
    SystemPage,
    Memories,
    Areas,
    Spirits,
    BirdSpirit
}